var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19995 3.20001C3.19995 2.77566 3.36852 2.36869 3.66858 2.06864C3.96864 1.76858 4.3756 1.60001 4.79995 1.60001H8.46875C8.89306 1.6001 9.29996 1.76873 9.59995 2.06881L12.3312 4.80001C12.6312 5.09999 12.7999 5.50689 12.8 5.93121V12.8C12.8 13.2244 12.6314 13.6313 12.3313 13.9314C12.0313 14.2314 11.6243 14.4 11.2 14.4H4.79995C4.3756 14.4 3.96864 14.2314 3.66858 13.9314C3.36852 13.6313 3.19995 13.2244 3.19995 12.8V3.20001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.4e616a841acdfde76dd9fadd350ca602.svg";
export { ForwardRef as ReactComponent };